module.exports = __webpack_public_path__ + "static/media/coin_bronze.e1c67c86.svg";